import { render, staticRenderFns } from "./GetLinkDialog.vue?vue&type=template&id=06af93b5&scoped=true&"
import script from "./GetLinkDialog.vue?vue&type=script&lang=ts&"
export * from "./GetLinkDialog.vue?vue&type=script&lang=ts&"
import style0 from "./GetLinkDialog.vue?vue&type=style&index=0&id=06af93b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06af93b5",
  null
  
)

export default component.exports